import BaseApi from "./Api";

class StatisticsApi extends BaseApi {
  url = "stats";
  constructor() {
    super();
    this.setResourceUrl(this.url);
  }

  fetchStats = () => {
    return this.instance({
      method: "get",
      url: this.url,
    });
  };

  fetchStatsCsv = () => {
    return this.instance({
      method: "get",
      url: this.url + "/download",
      responseType: "blob", // Important for file download
    });
  };
}

export default new StatisticsApi();
